@if (list$ | async; as list) {
    <mat-table [dataSource]="datasource">
        <ng-container matColumnDef="status" i18n>
            <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
            <mat-cell *matCellDef="let row">
                <div class="opportunity-status-label" [ngClass]="{
                            'color-green': row.status === 'Won',
                            'color-yellow': row.status !== 'Lost' && row.status !== 'Won',
                            'color-red': row.status === 'Lost'
                }">
                    {{ row.status }}
                </div>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="opportunityStage">
            <mat-header-cell *matHeaderCellDef i18n>Stage</mat-header-cell>
            <mat-cell *matCellDef="let row">
                {{ row.opportunityStage }}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="salesManager">
            <mat-header-cell *matHeaderCellDef i18n>Sales manager</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.createdBy }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="nextSteps">
            <mat-header-cell *matHeaderCellDef i18n>Next steps</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.nextSteps }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="potentialClosure">
            <mat-header-cell *matHeaderCellDef i18n>Potential closure</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.potentialClosureQuarter }}- {{ row.potentialClosureYear }}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="proposalSentOn">
            <mat-header-cell *matHeaderCellDef i18n>Proposal sent on</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.proposalSentOn | timestamp | date }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="proposalRequested">
            <mat-header-cell *matHeaderCellDef i18n>Proposal requested</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.proposalRequested | timestamp | date }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="nextFollowUpDate">
            <mat-header-cell *matHeaderCellDef i18n>Next follow-up</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.nextFollowUpDate | timestamp | date }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="followUpDate">
            <mat-header-cell *matHeaderCellDef i18n>Follow-up date</mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.followUpDate | timestamp | date }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="forecastAmount">
            <mat-header-cell *matHeaderCellDef i18n>Forecast amount</mat-header-cell>
            <mat-cell *matCellDef="let row">
                @if (row.currency === 'USD') {
                    <mat-icon style="margin-left: 2px; margin-top: 7px; font-size: 16px"
                              [matTooltip]="(row.forecastAmountITA) | currency: 'EUR'">
                        currency_exchange
                    </mat-icon>
                }
                {{ row.currency === 'USD' ? (row.forecastAmountUSA | currency: 'USD') : (row.forecastAmountITA | currency: 'EUR') }}
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let row">
                @if (row.latest) {
                    <button mat-icon-button (click)="editFollowUp(row)">
                        <mat-icon>edit</mat-icon>
                    </button>
                }
                @if (followUpCanBeDeleted(row)) {
                    <button mat-icon-button (click)="deleteFollowUp(row)">
                        <mat-icon>delete</mat-icon>
                    </button>
                }
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectFollowUp(row)"
                 [ngClass]="{'selected-row': selectedFollowUp?.id === row.id}"
        ></mat-row>
    </mat-table>
    <mat-paginator [length]="totalElements" [pageSizeOptions]="[5, 10, 25]" pageSize="10">
    </mat-paginator>
} @else {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

